/**
 * Parse the "Amount Approved" field input into a number (CREDIT-39).
 *
 * The previous implementation stripped everything except digits, which silently
 * dropped any cents the approver typed. This keeps digits and a single decimal point
 * so amounts like 50000.50 are preserved, while rejecting other characters.
 */
export function parseApprovedAmount(raw: string): number {
   let cleaned = (raw || "").replace(/[^0-9.]/g, "");

   const firstDot = cleaned.indexOf(".");
   if (firstDot !== -1) {
      // Keep only the first decimal point.
      cleaned = cleaned.slice(0, firstDot + 1) + cleaned.slice(firstDot + 1).replace(/\./g, "");
   }

   const parsed = parseFloat(cleaned);
   return isNaN(parsed) ? 0 : parsed;
}
